// import axios from "axios";
// import React from "react";
// import { Link } from "react-router-dom";
// import styled from "styled-components";
// import {
//   HomeIcon,
//   LogoutIcon,
//   ProfileIcon,
//   ReportIcon,
//   UserManualIcon
// } from "../../assets/icons/index";
// import { Logo } from "../../assets/svg/index";
// import NativeHelper from "../utils/nativeUtils";

// const NavWrapper = styled.div`
//   @media (min-width: 61.313em) {
//     margin: 1rem 2rem;
//     display: flex;

//     justify-content: space-between;
//   }
// `;
// const NavLinks = styled.ul`
//   display: flex;
// `;
// const LogoWrapper = styled.div`
//   width: 150px;
//   height: auto;
// `;
// const LinkName = styled.div`
//     cursor: pointer;
//     display: flex;
//     flex-direction: column;
//     align-items: center;

//   &>p{
//    visibility: hidden;
//   }
//   &:hover {
//   fill: var(--primary);
//     &>p{
//       visibility: visible;
//     }
//   }
// `;

// const IconWrapper = styled.div`
//   width: 25px;
//   height: 25px;
//   margin: 1rem 2rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;

//   &:hover {
//     cursor: pointer;
//     svg {
//       fill: var(--primary);
//     }
//     ${LinkName} {
//       visibility: visible;
//     }
//   }
// `;


// export default function HeaderDesktop() {
//   const logoutUser = async () => {

//     await axios.get(`${process.env.REACT_APP_API}/user/logout`, {
//       withCredentials: true
//     })
//     NativeHelper.logoutOneSignal();
//     // localStorage.removeItem("firstLogin");
//     localStorage.clear()
//     window.location.href = "/";
//   };

//   return (
//     <NavWrapper>


//       <Link to="/"> <LogoWrapper>
//         <Logo />
//       </LogoWrapper></Link>
//       <NavLinks>

//         <Link to="/">
//           <LinkName>
//             <IconWrapper>
//               <HomeIcon />
//             </IconWrapper>
//             <p>
//               Home
//             </p>
//           </LinkName>
//         </Link>
//         <Link to="/report">
//           <LinkName>
//             <IconWrapper>
//               <ReportIcon />
//             </IconWrapper>
//             <p>
//               Report
//             </p>
//           </LinkName>
//         </Link>
//         <Link to="/profile">
//           <LinkName>
//             <IconWrapper>
//               <ProfileIcon />
//             </IconWrapper>
//             <p>
//               Profile
//             </p>
//           </LinkName>
//         </Link>
//         <Link to="/User-Manual.pdf"
//           target="_blank"
//           rel="noreferrer"
//         >
//           <LinkName>
//             <IconWrapper>
//               <UserManualIcon />
//             </IconWrapper>
//             <p>
//               User Manual
//             </p>
//           </LinkName>
//         </Link>
//         <Link to="/" onClick={logoutUser}>
//           <LinkName>
//             <IconWrapper>
//               <LogoutIcon />
//             </IconWrapper>
//             <p>
//               Logout
//             </p>
//           </LinkName>
//         </Link>
//       </NavLinks>
//     </NavWrapper>
//   );
// }




import { GlobalState } from "../../GlobalState";
import axios from "axios";
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import {
  HomeIcon,
  LogoutIcon,
  ProfileIcon,
  ReportIcon,
  UserManualIcon
} from "../../assets/icons/index";
import { Logo } from "../../assets/svg/index";
import NativeHelper from "../utils/nativeUtils";
import Banner from "../utils/banner";
import { DashboardSvg } from "../../assets/svg";

const slideInFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const iconFloat = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-3px);
  }
`;

const textGlow = keyframes`
  0%, 100% {
    opacity: 0.9;
  }
  50% {
    opacity: 1;
  }
`;

const NavWrapper = styled.div`
  @media (min-width: 61.313em) {
    margin: 0.25rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    animation: ${slideInFromTop} 0.6s ease-out;
  }
`;

const LogoWrapper = styled(Link)`
  width: 150px;
  height: auto;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const NavLinks = styled.ul`
  display: flex;
  gap: 0.5rem;
`;

const NavItem = styled.li`
  list-style: none;
  animation: ${slideInFromTop} 0.6s ease-out;
  animation-fill-mode: both;
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
  &:nth-child(5) { animation-delay: 0.5s; }
`;

const IconWrapper = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  svg {
    transition: all 0.3s ease;
    fill: currentColor;
  }
`;

const LinkName = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background: var(--primary);
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    
    &::before {
      width: 80%;
    }
    
    & > p {
      visibility: visible;
      opacity: 1;
      animation: ${textGlow} 1s ease-in-out;
    }
    
    & ${IconWrapper} {
      animation: ${iconFloat} 1.5s ease-in-out infinite;
      
      svg {
        fill: var(--primary);
        transform: scale(1.1);
      }
    }
  }

  & > p {
    visibility: hidden;
    opacity: 0;
    margin: 0.3rem 0 0 0;
    font-size: 0.75rem;
    color: var(--text-color);
    transition: all 0.3s ease;
    font-weight: 500;
  }
`;

const LogoutButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background: #ff4757;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    background: rgba(255, 71, 87, 0.1);
    
    &::before {
      width: 80%;
    }
    
    & > p {
      visibility: visible;
      opacity: 1;
      color: #ff4757;
      animation: ${textGlow} 1s ease-in-out;
    }
    
    & ${IconWrapper} {
      animation: ${iconFloat} 1.5s ease-in-out infinite;
      
      svg {
        fill: #ff4757;
        transform: scale(1.1);
      }
    }
  }

  & > p {
    visibility: hidden;
    opacity: 0;
    margin: 0.3rem 0 0 0;
    font-size: 0.75rem;
    transition: all 0.3s ease;
    font-weight: 500;
  }
`;

export default function HeaderDesktop() {
  const [isVisible, setIsVisible] = useState(false);
  const state = useContext(GlobalState);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const logoutUser = async () => {
    try {
      await axios.get(`${process.env.REACT_APP_API}/user/logout`, {
        withCredentials: true
      });
      localStorage.removeItem("accessToken");
      localStorage.removeItem("org_id");  // prevent previous user's org_id from persisting
      window.location.href = "/";
    } catch (error) {
      console.error("Logout error:", error);
      localStorage.removeItem("accessToken");
      localStorage.removeItem("org_id");
      window.location.href = "/";
    }
  };

  return (
    <NavWrapper>
      <LogoWrapper to="/">
        <Logo />
      </LogoWrapper>

      <NavLinks>
        {/* <NavItem>
          <Link to="/">
            <LinkName>
              <IconWrapper>
                <HomeIcon />
              </IconWrapper>
              <p>Home</p>
            </LinkName>
          </Link>
        </NavItem>
        
        <NavItem>
          <Link to="/report">
            <LinkName>
              <IconWrapper>
                <ReportIcon />
              </IconWrapper>
              <p>Report</p>
            </LinkName>
          </Link>
        </NavItem>
        
        <NavItem>
          <Link to="/profile">
            <LinkName>
              <IconWrapper>
                <ProfileIcon />
              </IconWrapper>
              <p>Profile</p>
            </LinkName>
          </Link>
        </NavItem> */}

        {/* <NavItem>
          <Link 
            to="/User-Manual.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <LinkName>
              <IconWrapper>
                <UserManualIcon />
              </IconWrapper>
              <p>User Manual</p>
            </LinkName>
          </Link>
        </NavItem> */}
        <NavItem>
          <Link
            to="/User-Manual.pdf"
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              if (window.innerWidth <= 768) {
                e.preventDefault();
                window.open(
                  `https://docs.google.com/viewer?url=${window.location.origin}/User-Manual.pdf&embedded=true`,
                  "_blank"
                );
              }
            }}
          >
            <LinkName>
              <IconWrapper><UserManualIcon /></IconWrapper>
              <p>User Manual</p>
            </LinkName>
          </Link>
        </NavItem>


        {/* <Link 
            to="/profile" 
            style={{
width: "700px"
  }}

          >
               <Banner
          title={`Welcome ${state.userAPI.name}`}
          subtitle=""
          tooltip="View Your Profile"
        >
        
                <DashboardSvg />
              </Banner>
              </Link> */}

        <NavItem>
          <LogoutButton onClick={logoutUser}>
            <IconWrapper>
              <LogoutIcon />
            </IconWrapper>
            <p>Logout</p>
          </LogoutButton>
        </NavItem>
      </NavLinks>
    </NavWrapper>
  );
}
